<template>
    <div class="scoped-headhunterDetail">
        <div class="white-block">
            <p>
                <el-button type="text" @click="$router.push({name: 'supplier'})"><i class="el-icon-my-zuo ml-5"></i> 返回供应商列表</el-button>
            </p>
            <el-row class="banner-text mt-10">
                <el-col :span="5">
                    <p class="line-text-1"><span style="font-weight: bold;font-size: 22px;">{{ supplier.linkman }}</span>（{{ getSourceName(supplier.companyAbbr) }}）</p>
                </el-col>
                <el-col :span="5">
                    <p-icon class="line-text-1" icon-name="phone">{{ supplier.tel }}</p-icon>
                    <p-icon class="line-text-2" icon-name="email">{{ supplier.email }}</p-icon>
                </el-col>
                <el-col :span="7">
                    <p-icon class="line-text-1" icon-name="list">{{ supplier.companyFullName }}</p-icon>
                    <p-icon class="line-text-2" icon-name="clock">{{ supplier.createTime }}</p-icon>
                </el-col>
            </el-row>
            <el-row class="supplier-bottom">
                <el-col :span="5">
                    <label>跟进HR：</label>
                    <span>{{ supplier.applicant }}</span>
                </el-col>
                <el-col :span="5">
                    <label>签约部门：</label>
                    <span>{{ supplier.projectName }}</span>
                </el-col>
                <el-col :span="14">
                    <label>备注：</label>
                    <span>{{ supplier.remark }}</span>
                </el-col>
            </el-row>
            <div>
                <div class="filter-result-header clearfix mt-20 mt-20">
                    <span class="title" style="font-size: 18px;color: #333;">子账号列表（{{dynamicForm.tableData.length}}）</span>
                    <el-button style="float: right;" @click="addRow" icon="el-icon-plus">添加账号</el-button>
                </div>
                <el-form :model="dynamicForm" ref="ruleTableForm" class="demo-ruleForm mt-20">
                    <el-table
                            :data="dynamicForm.tableData"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                label="对接人"
                                align="center"
                                width="180">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEditStatus" v-text="scope.row.name"></span>
                                <el-input v-if="scope.row.isEditStatus" v-model="scope.row.name"
                                          placeholder="请输入对接人" :maxlength="50"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="对接人电话"
                                align="center"
                                width="180">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEditStatus" v-text="scope.row.phone"></span>
                                <el-form-item v-if="scope.row.isEditStatus"
                                              style="margin-top: 22px"
                                              :prop="'tableData.'+scope.$index+'.phone'"
                                              :rules="[{required: true, message: '请输入对接人电话', trigger: 'blur'},
                                              {pattern:/^[0-9]+$/, message: '请输入数字', trigger: 'blur,change'}]">
                                    <el-input v-model="scope.row.phone"
                                              placeholder="请输入对接人电话" :maxlength="20"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="对接人邮箱">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEditStatus" v-text="scope.row.email"></span>
                                <el-form-item v-if="scope.row.isEditStatus"
                                              style="margin-top: 22px"
                                              :prop="'tableData.'+scope.$index+'.email'"
                                              :rules="[
                                              { required: true, message: '请输入对接人邮箱', trigger: 'blur'},
                                              { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }]">
                                    <el-input v-if="scope.row.isEditStatus" v-model="scope.row.email"
                                              placeholder="请输入对接人邮箱" :maxlength="50"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="所属地区">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEditStatus && scope.row.citys" >{{ getSelectMapText('WB_POSITION_CITY', scope.row.citys) }}</span>
                                <el-form-item v-if="scope.row.isEditStatus"
                                    style="margin-top: 22px"
                                    :prop="'tableData.'+scope.$index+'.citys'"
                                    :rules="[{required: true, type: 'array', message: '请选择对接人所属地区', trigger: 'blur'}]">
                                    <el-select v-model="scope.row.citys" multiple>
                                        <el-option
                                            v-for="(item, idx) in selectMap.WB_POSITION_CITY"
                                            :key="idx"
                                            :label="item.text"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="最近操作人/时间">
                            <template slot-scope="scope">
                                <span v-text="(scope.row.lastOperateName || '') + ' ' + (scope.row.modifyTime || '')"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                align="center"
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-button v-if="!scope.row.isEditStatus" type="text" icon="el-icon-my-bianji color-info"
                                           @click="editRow(scope.$index, scope.row)"></el-button>
                                <el-button v-if="!scope.row.isEditStatus" type="text" icon="el-icon-my-shanchu color-danger"
                                           @click="deleteRow(scope.$index, scope.row)"></el-button>
                                <el-button v-if="scope.row.isEditStatus" type="text" icon="el-icon-check color-success"
                                           @click="saveRow(scope.$index, scope.row)"></el-button>
                                <el-button v-if="scope.row.isEditStatus" type="text" icon="el-icon-my-guanbi color-danger"
                                           @click="cancelRow(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import TextBanner from 'components/textBanner'
    import PIcon from 'components/pIcon'
    import axios from 'axios'
    import pattern from 'modules/pattern'
    import SelectMapMixin from 'mixins/selectMapMixin'
    import CompanyListMixin from './companyList'
    export default {
        data () {
            return {
                companyId: this.$route.query.id,
                supplier: {},
                dynamicForm: {
                    tableData: [{
                        hunterPhone: ''
                    }]
                },
                pattern: pattern
            }
        },
        mixins: [SelectMapMixin, CompanyListMixin],
        computed: {
        },
        methods: {
            sizeChange (val) {
                console.log(val)
            },
            currentChange (val) {
                console.log(val)
            },
            editRow (index, row) {
                row.__resetCopy = Object.assign({}, row)
                this.$set(row, 'isEditStatus', true)
            },
            deleteRow (index, row) {
                this.$confirm('是否删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/supplierLinkman/delete.api', {id: row.id}, {'X-showMessage': true}).then(res => {
                        this.dynamicForm.tableData = this.dynamicForm.tableData.filter(item => item.id !== row.id)
                    }).catch(() => {})
                })
            },
            addRow (index, row) {
                this.dynamicForm.tableData.push({
                    'isEditStatus': true,
                    'name': '',
                    'email': '',
                    'phone': '',
                    'citys': []
                })
            },
            saveRow (index, row) {
                this.$refs['ruleTableForm'].validate((valid) => {
                    if (valid) {
                        let postUrl = row.id ? '/supplierLinkman/update.api' : '/supplierLinkman/insert.api',
                            postData = {
                                id: row.id || '',
                                supplierId: this.companyId,
                                name: row.name,
                                email: row.email,
                                phone: row.phone,
                                citys: row.citys.join(',')
                            }
                        axios.post(postUrl, postData, {'X-showMessage': true}).then(res => {
                            let bean = res.result && res.result.bean
                            if (bean) {
                                for (let name in row) {
                                    this.$set(row, name, bean[name])
                                }
                                this.$set(row, 'lastOperateName', bean.lastOperateName)
                                this.$set(row, 'modifyTime', bean.modifyTime)
                                this.$set(row, 'id', bean.id)
                                this.$set(row, 'citys', bean.citys ? bean.citys.split(',') : [])
                            }
                            this.$set(row, 'isEditStatus', false)
                        }).catch((err) => {})
                    } else {
                        return false
                    }
                })
            },
            cancelRow (index, row) {
                if (row.id) {
                    Object.assign(row, row.__resetCopy)
                    delete row.__resetCopy
                    this.$set(row, 'isEditStatus', false)
                } else {
                    this.dynamicForm.tableData.pop()
                }
            },
            getSelectMapText (selectMapName, value, separator = ',') {
                value = JSON.parse(JSON.stringify(value))
                let text = '',
                    list = selectMapName instanceof Array ? selectMapName : this.selectMap[selectMapName],
                    curValue = '',
                    resultTxt = []
                if (!(value instanceof Array)) {
                    value = [value]
                }
                curValue = value.shift()
                while (typeof curValue !== 'undefined' && list) {
                    for (let index = 0; index < list.length; index++) {
                        let item = list[index]
                        if (item.value === String(curValue)) {
                            resultTxt.push(item.text)
                            break
                        }
                    }
                    curValue = value.shift()
                }
                return (resultTxt.length === 1 ? resultTxt[0] : resultTxt.join(separator))
            }
        },
        components: {
            TextBanner,
            PIcon
        },
        created () {
            axios.get('/supplier/selectByKey.api', {params: {id: this.companyId}}).then(res => {
                this.supplier = res.result.bean
            })
            axios.get('/supplierLinkman/list.api', {params: {supplierId: this.companyId}}).then(res => {
                let result = res.result
                this.dynamicForm.tableData = result.list.map(el => {
                    el.citys = el.citys ? el.citys.split(',') : []
                    return el
                })
            })
        }
    }
</script>

<style type="text/css" lang="scss">
    @import "~variable";

    .scoped-headhunterDetail {
        .white-block{
            background: #fff;
            padding: 20px;
            min-height: 700px;
        }
        .supplier-bottom{
            border: 1px solid #2481ff;
            color: #999;
            padding: 5px 20px;
            margin-top: -1px;
            border-radius: 0 0 5px 5px;
        }
        .banner-text {
            padding : 15px 20px;
            border: 1px solid #2481ff;
            background: #2481ff;
            color: #fff;
            border-radius: 5px 5px 0 0;
        }
        .subTitle {
            width : 500px;
        }
    }
</style>


// WEBPACK FOOTER //
// supplierUsers.vue?17364c56